import classnames from 'classnames';
import { PureComponent } from 'react';

import styles from './index.module.scss';

type PropsT = {
  /** Extra classnames */
  className?: string;
};

export class CSATWidgetMessage extends PureComponent<PropsT> {
  render() {
    const { className, children } = this.props;
    const rootClassName = classnames(styles.root, className);

    return <div className={rootClassName}>{children}</div>;
  }
}
